module.exports = __webpack_public_path__ + "0e76de460a03e1d0783a04b56cd34ff4.svg";